const state = {
  snackNum: 0,
  roomId: 0,
  masterId: 0,
  masterName: "none",
  leaderId: 0,

  gameState: "none",
}

const getters = {
  roomId: state => state.roomId,
  masterId: state => state.masterId,
  masterName: state => state.masterName,
  leaderId: state => state.leaderId,
  gameState: state => state.gameState,
}

const actions = {
  setGameInfo({ commit }) {
    commit('setGameInfo')
  },
  setRoomId({ commit }) {
    commit('setRoomId')
  },
  clearGameInfo({ commit }) {
    commit('clearGameInfo')
  },
  incrementSnackNum({ commit }) {
    commit('incrementSnackNum')
  },
  decrementSnackNum({ commit }) {
    commit('decrementSnackNum')
  }
}

const mutations = {
  setGameInfo(state, payload) {
    Object.keys(payload).forEach(function(key) {
      state[key] = payload[key];
    });
  },
  setRoomId(state, payload) {
    state['roomId'] = payload.roomId
  },
  clearGameInfo(state) {
    state.roomId = 0
    state.masterId = 0,
    state.masterName = "none"
    state.leaderId = 0
    state.gameState = "none"
  },
  incrementSnackNum(state) {
    state.snackNum += 1
  },
  decrementSnackNum(state) {
    state.snackNum -= 1
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
